// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__ControlPane__base","container":"cms__ControlPane__container","rounded":"cms__ControlPane__rounded","depth":"cms__ControlPane__depth","clearfix":"cms__ControlPane__clearfix","control":"cms__ControlPane__control","label":"cms__ControlPane__label","labelWithError":"cms__ControlPane__labelWithError cms__ControlPane__label","errors":"cms__ControlPane__errors"};


//////////////////
// WEBPACK FOOTER
// ./components/ControlPanel/ControlPane.css
// module id = 259
// module chunks = 0